import './Work_slider.css';
import { Fade } from "react-awesome-reveal";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

function Work_slider() {
    const scrollRef = useRef();
    const [popupImg, setPopupImg] = useState(null); 
    const [collections, setCollections] = useState([]);
    const [loadingImages, setLoadingImages] = useState({});

    useEffect(() => {
        if (scrollRef.current) scrollRef.current.scrollLeft = 0;
        fetchCollections();
    }, []);

    const fetchCollections = async () => {
        try {
            const res = await axios.get("https://himchatterjee.in/backend/collections.php");
            setCollections(res.data);

            // Initialize loader state for each image
            const initialLoading = {};
            res.data.forEach(item => {
                initialLoading[item.id] = true;
            });
            setLoadingImages(initialLoading);

        } catch (err) {
            console.error("Error fetching collections:", err);
        }
    };

    const handleImageLoad = (id) => {
        setLoadingImages(prev => ({ ...prev, [id]: false }));
    };

    const handleImageClick = (imgSrc) => setPopupImg(imgSrc);
    const handleClosePopup = () => setPopupImg(null);

    return (
        <>
            <Fade direction="left" duration={1500} triggerOnce>
                <h1 className='hed'>Featured Collections</h1>
            </Fade>

            <div className="foodBox" ref={scrollRef}>
                <div className="scroll-container">
                    {collections.map((item) => (
                        <Fade key={item.id} direction="left">
                            <div className="card1" onClick={() => handleImageClick(item.file_path)}>
                                <div className="media-container">
                                    {/* Loader overlay */}
                                    {loadingImages[item.id] && (
                                        <div className="media-loader-overlay">
                                            <div className="loader"></div>
                                        </div>
                                    )}

                                    <img
                                        src={item.file_path}
                                        alt={item.heading}
                                        onLoad={() => handleImageLoad(item.id)}
                                        style={{ display: loadingImages[item.id] ? "none" : "block" }}
                                    />

                                    <div className="text1">
                                        <h1>{item.heading}</h1>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    ))}
                </div>
            </div>

            {popupImg && (
                <div className="popup-overlay" onClick={handleClosePopup}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={handleClosePopup}>×</button>
                        <img src={popupImg} alt="Full view" />
                    </div>
                </div>
            )}
        </>
    );
}

export default Work_slider;
